// This file is required for Expo/React Native SQLite migrations - https://orm.drizzle.team/quick-sqlite/expo

import journal from './meta/_journal.json';
import m0000 from './0000_smooth_psylocke.sql';
import m0001 from './0001_last_silver_samurai.sql';
import m0002 from './0002_bold_wolfsbane.sql';
import m0003 from './0003_normalize_recurrence.sql';
import m0004 from './0004_recurrence_advanced.sql';
import m0005 from './0005_multi_category_budgets.sql';
import m0006 from './0006_personal_loans.sql';
import m0007 from './0007_goal_deposit_account.sql';
import m0008 from './0008_invoice_health_seal.sql';
import m0009 from './0009_auto_rules_soft_delete.sql';
import m0010 from './0010_recurring_occurrence_date.sql';
import m0011 from './0011_tag_sort_order.sql';
import m0012 from './0012_health_analyses.sql';
import m0013 from './0013_recurring_skipped_dates.sql';
import m0014 from './0014_recurring_transaction_tags.sql';
import m0015 from './0015_reservas.sql';
import m0016 from './0016_goals_become_virtual.sql';
import m0017 from './0017_reserva_emergency_fund.sql';
import m0018 from './0018_recurring_notes.sql';
import m0019 from './0019_sync_junction_unique.sql';
import m0020 from './0020_sync_outbox.sql';
import m0021 from './0021_sync_store.sql';
import m0022 from './0022_transaction_is_ignored.sql';
import m0023 from './0023_personal_loan_schedule.sql';
import m0024 from './0024_pending_dedupe_window.sql';
import m0025 from './0025_sync_pending_upload.sql';
import m0026 from './0026_budget_type.sql';
import m0027 from './0027_unlink_dangling_payment_account.sql';
import m0028 from './0028_dedupe_invoice_expense.sql';
import m0029 from './0029_round_invoice_amounts.sql';
import m0030 from './0030_financing_kind.sql';
import m0031 from './0031_subcategory_seed_name.sql';
import m0032 from './0032_budget_subcategory_limits.sql';
import m0033 from './0033_financing_amortization_curve.sql';
import m0034 from './0034_card_due_on_business_day.sql';
import m0035 from './0035_notification_issuer_hint.sql';
import m0036 from './0036_pending_notifications_created_at_index.sql';
import m0037 from './0037_budget_origins.sql';
import m0038 from './0038_budget_subcategories.sql';
import m0039 from './0039_ios_quick_capture.sql';
import m0040 from './0040_budget_cycle.sql';
import m0041 from './0041_card_transactions_drop_account.sql';
import m0042 from './0042_card_closing_day_to_next_invoice.sql';
import m0043 from './0043_reserva_movement_transaction.sql';
import m0044 from './0044_reserva_yield_income_ignored.sql';
import m0045 from './0045_recurring_is_ignored.sql';

  export default {
    journal,
    migrations: {
      m0000,
m0001,
m0002,
m0003,
m0004,
m0005,
m0006,
m0007,
m0008,
m0009,
m0010,
m0011,
m0012,
m0013,
m0014,
m0015,
m0016,
m0017,
m0018,
m0019,
m0020,
m0021,
m0022,
m0023,
m0024,
m0025,
m0026,
m0027,
m0028,
m0029,
m0030,
m0031,
m0032,
m0033,
m0034,
m0035,
m0036,
m0037,
m0038,
m0039,
m0040,
m0041,
m0042,
m0043,
m0044,
m0045
    }
  }
